import { Head } from 'head/Head';

export function BaseHead() {
  return (
    <Head
      title="Home"
      description="Book reservations and culinary experiences at restaurants, bars, wineries and pop-ups across the globe."
      keywords="restaurant reservations, experiences, tickets, prix fixe, tickets, dining, restaurants, bookings, tickets, prix fixe, profile, payments, credit card, transactions"
      initializeDefaultSettings
    />
  );
}
